import {HwOpening} from "../../../../api/Hardware";
import {ConfigureDegrees} from "./configure/ConfigureDegrees";
import React, {useRef, useState} from "react";
import {useReloader} from "./ReloadContext";
import {IconButton, Typography} from "@mui/material";
import {Popover} from "../../../../misc/Popover";
import {Close} from "@mui/icons-material";
import {css} from "@emotion/css";

export function DegreesOpeningDetail(props: {
    hardwareGroup: number;
    value: HwOpening;
}) {
    const [showDegrees, setShowDegrees] = useState<HTMLElement|null>(null);
    const reloadOnCloseRef = useRef(false);
    const reloadRef = useReloader();

    if(props.value.degreesOfOpeningActive === null && props.value.degreesOfOpeningInactive === null) {
        return null;
    }

    const closeIt = () => {
        setShowDegrees(null)

        if(reloadOnCloseRef.current) {
            reloadOnCloseRef.current = false
            reloadRef.current();
        }
    }

    return (
        <div style={{
            display: "flex",
            gap: 4,
        }}>
            <button className={buttonCls} onClick={e => setShowDegrees(e.currentTarget)}>
                {props.value.degreesOfOpeningActive && <div>Active: {props.value.degreesOfOpeningActive}°</div>}
                {props.value.degreesOfOpeningInactive && <div>Inactive: {props.value.degreesOfOpeningInactive}°</div>}
            </button>

            {showDegrees &&
                <Popover open anchorEl={showDegrees} onClose={() => closeIt()}>
                    <div style={{
                        paddingLeft: 16,
                        paddingTop: 16,
                        display: "flex",
                        gap: 8,
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <Typography variant="h6">
                            Configure Degrees
                        </Typography>
                        <IconButton onClick={() => closeIt()}>
                            <Close />
                        </IconButton>
                    </div>
                    <ConfigureDegrees
                        hardwareGroupId={props.hardwareGroup}
                        opening={props.value.id}
                        isPair={props.value.openingType === "Pair"}
                        onUpdate={() => {
                            reloadOnCloseRef.current = true;
                        }} />
                </Popover>
            }
        </div>
    )
}

const buttonCls = css({
    border: "none",
    background: "transparent",
    cursor: "pointer",

    fontWeight: "inherit",
    fontFamily: "inherit",

    "&:hover":{
        textDecoration: "underline",
    }
})